import { render, staticRenderFns } from "./store.vue?vue&type=template&id=487c2960&scoped=true&"
import script from "./store.vue?vue&type=script&lang=js&"
export * from "./store.vue?vue&type=script&lang=js&"
import style0 from "./store.vue?vue&type=style&index=0&id=487c2960&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487c2960",
  null
  
)

export default component.exports